import React from 'react';
import { Link } from 'react-router-dom';

interface Props {
    href: string;
    label?: string;
}

export const AddButton = ({ href, label = 'Agregar' }: Props) => {
    return (
        <Link to={href} className='btn btn-square btn-primary'>
            <i className='mdi mdi-plus-circle'></i> {label}
        </Link>
    );
};
